<div
    [ngClass]="classes"
    (click)="onClick($event)"
    [class.pointer]="clickCallback"
>
    @if (icon) {
        <wdx-icon
            [class.me-2]="text"
            [scale]="iconScale"
            [icon]="icon.name"
            [disableTooltip]="!iconToolTip"
            [ngbTooltip]="iconToolTip | translateTokenisedString"
            container="body"
        ></wdx-icon>
    }
    @if (text) {
        <span class="text-truncate">{{ text }}</span>
    }
</div>
